"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var BestOfferCounteredDeclinedByComponent = (function () {
    function BestOfferCounteredDeclinedByComponent() {
    }
    BestOfferCounteredDeclinedByComponent.prototype.ngOnInit = function () {
    };
    return BestOfferCounteredDeclinedByComponent;
}());
BestOfferCounteredDeclinedByComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-best-offer-countered-declined-by',
                template: "<span class=\"db-best-offer-countered-declined-by\" data-a8n=\"db-best-offer-countered-declined-by\">\n  {{ 'dealerBlockLayout.declinedBy' | translate }}\n  <span *ngIf=\"boCounteredDeclinedBy && boCounteredDeclinedBy.toLowerCase() === 'seller'\">{{ 'dealerBlockLayout.seller' | translate }}</span>\n  <span *ngIf=\"boCounteredDeclinedBy && boCounteredDeclinedBy.toLowerCase() === 'buyer'\">{{ 'dealerBlockLayout.buyer' | translate }}</span>\n</span>\n",
                styles: [""]
            },] },
];
/** @nocollapse */
BestOfferCounteredDeclinedByComponent.ctorParameters = function () { return []; };
BestOfferCounteredDeclinedByComponent.propDecorators = {
    'boCounteredDeclinedBy': [{ type: core_1.Input },],
};
exports.BestOfferCounteredDeclinedByComponent = BestOfferCounteredDeclinedByComponent;
//# sourceMappingURL=best-offer-countered-declined-by.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/best-offer-countered-declined-by/best-offer-countered-declined-by.component.js
// module id = eUfj
// module chunks = 0